/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUserMlpDto } from '../../models/create-user-mlp-dto';
import { UserMlpResponseDto } from '../../models/user-mlp-response-dto';

export interface AdminUserMlpControllerCreateUserMlp$Params {
      body: CreateUserMlpDto
}

export function adminUserMlpControllerCreateUserMlp(http: HttpClient, rootUrl: string, params: AdminUserMlpControllerCreateUserMlp$Params, context?: HttpContext): Observable<StrictHttpResponse<UserMlpResponseDto>> {
  const rb = new RequestBuilder(rootUrl, adminUserMlpControllerCreateUserMlp.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserMlpResponseDto>;
    })
  );
}

adminUserMlpControllerCreateUserMlp.PATH = '/admin/user-mlp';
